import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Languages from './components/Languages';
import Services from './components/Services';
import WhyPTS from './components/WhyPTS';
import Quote from './components/Quote';
import ServicesLists from './components/ServicesLists';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Languages />
      <Services />
      <ServicesLists /> {/* ✅ Add this line */}
      <WhyPTS />
      <Quote />
      <Footer /> {/* ✅ Add Footer at the end */}
    </div>
  );
}

export default App;
